
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";
import { OptionalGet_SelectAPI } from "../../../../../helper/Redux/Slices/DashboardSlice/DashboardSlice";
import { LogoLoader } from "../../../../../helper/Loaders/LogoLoader";
import { useAuthState } from "../../../../../helper/Context/context";

export default function OptionalSubjectModal(props) {
    const Navigate = useNavigate()
    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth } = userDetails
    const { UserID, token } = userDetails.user

    const { handleCloseOptional, showOptional, ModalName } = props

    const { optionalSub_M_IndicatorID, m_SubSubjectID, m_MainSubjectID } = showOptional

    const [isLoading, setisLoading] = useState(false)
    const [GridData, setGridData] = useState([])

    useEffect(() => {
        handleFetchData()
    }, [])

    const handleFetchData = () => {
        setisLoading(true)
        const data = {
            M_FinancialYearID: year.Label != "Year ....." ? year.Label : '0',
            M_MonthID: Month.ID,
            T_ExaminationFormID: '0',
            M_MainSubjectID: m_MainSubjectID ? m_MainSubjectID : '0',
            M_SubSubjectID: m_SubSubjectID ? m_SubSubjectID : '0',
            OptionalSub_M_IndicatorID: optionalSub_M_IndicatorID ? optionalSub_M_IndicatorID : '0',
            Flag: 'OptionalSubject_Count',
            M_UserID: UserID,
            token: token,
            setisLoading: setisLoading,
            handleGetData: handleGetData,
        }
        OptionalGet_SelectAPI({ data })
    }

    const handleGetData = (value) => {
        setGridData(value)
    }
    

    return (
        <>
            <div className="modal fade show" style={{ display: "block", backgroundColor: "#00000055" }}>
                <div className="modal-dialog modal_popup" role="document" >
                    <div className="modal-content ">
                        <div className="modal-header d-fles justify-content-between px-lg-5">

                            <h5 className="modal-title fw-bold" id="exampleModalLongTitle">
                                {ModalName ? ModalName : ''} - Optional Subject
                            </h5>

                            <button
                                onClick={() => handleCloseOptional()}
                                type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        {isLoading && <LogoLoader />}

                        <div className="modal-body mx-4">

                            <div className="row px-lg-5 py-lg-3 card-body " style={{ height: '500px', overflow: "auto" }}>

                                {
                                    GridData && GridData?.length > 0 ? GridData.map((L) => {
                                        return (
                                            <div className="row col-12 col-lg-6  " >
                                                <div className="px-lg-3 mb-0 pb-2">
                                                    <div className="row  border rounded  mb-0 mx-lg-2" >
                                                        <div className="col-10 pt-2">
                                                            <p className="mb-0 pb-0"> <i class="fa-solid fa-sailboat fs-9 pe-2"></i>{L?.paramName}</p>
                                                        </div>
                                                        <div className="col-2 pt-2 text-center" style={{ borderLeft: '1px solid #DEE2E6' }}>
                                                            <h5 style={{ color: 'red', fontWeight: 'bold' }} className={L?.totalCount > 0 ? "cursor-pointer" : ""}
                                                                onClick={() => {
                                                                    L?.totalCount > 0 ?
                                                                        Navigate(`/LicentiateCertificate?paramName=${ModalName +' - '+ L?.paramName}&m_MainSubjectID=${L?.m_MainSubjectID}&m_SubSubjectID=${L?.m_SubSubjectID}&optionalSub_M_IndicatorID=${L?.optionalSub_M_IndicatorID}`)
                                                                        :
                                                                        console.log('')
                                                                }}
                                                            > {L?.totalCount}</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                        :
                                        <div className="text-center col-12">
                                            <text>No Record Found ...</text>
                                        </div>
                                }

                            </div>
                        </div>


                    </div>
                </div>
            </div>

        </>
    )
}